import CalendarType from '../CalendarType.js';
var registry = new Map();
export default {
    getCalendarClass: function (calendarType) {
        return registry.get(calendarType);
    },
    setCalendarClass: function (calendarType, Klass) {
        registry.set(calendarType, Klass);
    }
};